'use client'

import { useTranslation } from '@/hooks/client/use-translation'

interface ResultsEmptyProps {
  onClearFilters: () => void
}

// Empty result: say what happened and offer the way out.
export const ResultsEmpty = ({ onClearFilters }: ResultsEmptyProps) => {
  const { t } = useTranslation()
  return (
    <div className="border-navy/10 mt-6 rounded-2xl border bg-white px-6 py-12 text-center">
      <p className="text-navy text-[18px] font-semibold">
        {t('directory.noMatchTitle', 'No hearing aids match these filters.')}
      </p>
      <p className="text-navy/70 mt-2 text-[15px]">
        {t('directory.noMatchSubtitle', 'Remove a filter to widen the results, or clear them all.')}
      </p>
      <button
        type="button"
        data-tracking="ignore"
        onClick={onClearFilters}
        className="bg-navy hover:bg-navy/90 mt-6 inline-flex min-h-[44px] cursor-pointer items-center rounded-xl px-5 text-[15px] font-semibold text-white transition-colors"
      >
        {t('directory.clearFilters', 'Clear filters')}
      </button>
    </div>
  )
}
